import { render, staticRenderFns } from "./combinationCourse.vue?vue&type=template&id=2363c1d4&scoped=true&"
import script from "./combinationCourse.vue?vue&type=script&lang=js&"
export * from "./combinationCourse.vue?vue&type=script&lang=js&"
import style0 from "./combinationCourse.vue?vue&type=style&index=0&id=2363c1d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363c1d4",
  null
  
)

export default component.exports